module.exports = __webpack_public_path__ + "img/Frame_28.afb0071c.png";